<template>
  <router-view />
</template>

<script>
  export default {
    name: 'App',
    metaInfo () {
      return {
        title: 'SotalCloud VOD',
        titleTemplate:
          '%s | SotalCloud VOD',
      }
    },
    created () {
    },
    methods: {
    },
  }
</script>
